import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, IconButton } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import { PurchaseOrderDetailsContext, PurchaseOrderDetailsValues } from '../../contexts/PurchaseOrderDetailsContext';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

export const PurchaseOrderDetailsStockCheckModal = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('purchaseOrderDetails');

  const { acceptStockCountModal, isStockCheckModalOpen, closeStockCountModal } = useContext(PurchaseOrderDetailsContext) as PurchaseOrderDetailsValues;

  const goToStockCheck = () => {
    navigate('/store/stock-count');
  };

  return (
    <Dialog onClose={closeStockCountModal}
      open={isStockCheckModalOpen}>
      <DialogTitle>
        {t('stockCheckModal.title')}
      </DialogTitle>
      <IconButton aria-label={t('stockCheckModal.close')}
        onClick={closeStockCountModal}
        sx={{
          position: 'absolute',
          right: 16,
          top: 8,
          color: (theme) => theme.palette.custom.gray[800],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent>
        <Typography>
          {t('stockCheckModal.body')}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ m: 4 }}>
        <Button variant='badSecondary'
          size="lg"
          onClick={acceptStockCountModal}>
          {t('stockCheckModal.continueAnyway')}
        </Button>
        <Button variant='primary'
          size="lg"
          onClick={goToStockCheck}>
          {t('stockCheckModal.viewStockCounts')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};